import {useEffect} from 'react';
import YandexPvzWidget from './YandexPvzWidget';

/**
 * Модальное окно с картой ПВЗ. После подтверждения пункта в виджете вызывает onPicked и закрывается.
 */
const YandexPvzPickerModal = ({
    open,
    onClose,
    stationId,
    /** Строка для поля поиска виджета (город или полный адрес); виджет подставляет в city и запускает поиск. */
    searchPreset,
    remountKey,
    onPicked,
}) => {
    useEffect(() => {
        if (!open) {
            return undefined;
        }
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = prev;
        };
    }, [open]);

    if (!open) {
        return null;
    }

    const preset = (searchPreset && String(searchPreset).trim()) || '';

    return (
        <div className="fixed inset-0 z-[220] flex items-end justify-center p-0 sm:items-center sm:p-4">
            <button
                type="button"
                className="absolute inset-0 bg-bark-900/50 backdrop-blur-sm"
                aria-label="Закрыть"
                onClick={onClose}
            />
            <div
                className="relative flex max-h-[min(92vh,720px)] w-full max-w-4xl flex-col overflow-hidden rounded-t-3xl border border-stone-200/80 bg-white shadow-2xl sm:rounded-3xl"
                role="dialog"
                aria-modal="true"
                aria-labelledby="yandex-pvz-modal-title"
            >
                <div className="flex items-start justify-between gap-3 border-b border-stone-100 px-4 py-3 sm:px-5">
                    <h2 id="yandex-pvz-modal-title" className="text-lg font-semibold text-bark-900">
                        Выбор пункта выдачи
                    </h2>
                    <button
                        type="button"
                        className="rounded-full px-3 py-1 text-sm font-medium text-bark-600 hover:bg-stone-100"
                        onClick={onClose}
                    >
                        Закрыть
                    </button>
                </div>
                <div className="min-h-[min(480px,55vh)] flex-1 overflow-auto px-3 pb-4 pt-3 sm:px-5">
                    {stationId ? (
                        <YandexPvzWidget
                            key={`${remountKey}-${stationId}-${preset}`}
                            active
                            city={preset}
                            sourcePlatformStation={stationId}
                            onSelectionChange={(p) => {
                                onPicked?.(p);
                                onClose();
                            }}
                        />
                    ) : (
                        <p className="text-sm text-amber-800">Станция отгрузки не задана.</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default YandexPvzPickerModal;
